import React from 'react';

/**
 * L'avís que surt quan un alumne prova de copiar o enganxar.
 *
 * Va en un component propi perquè el bloqueig és a dues pantalles —l'exercici i
 * el detall del cas— i el text ha de dir el mateix a totes dues. Si l'alumne
 * llegeix una cosa diferent segons on ho provi, sembla una avaria.
 *
 * Diu el motiu i no només que està prohibit: sense el perquè, el primer que
 * pensa qui ho troba és que la pantalla s'ha penjat, i acaba avisant
 * l'instructor enmig de l'examen.
 */
function AvisCopia({ visible }) {
  if (!visible) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 pointer-events-none">
      <div className="flex items-center gap-2 px-4 py-3 rounded-lg shadow-lg bg-surface border border-border">
        <svg className="w-5 h-5 text-warning flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
        </svg>
        <p className="text-sm text-content-secondary">
          Copiar i enganxar estan desactivats en aquest exercici. L'anàlisi l'has d'escriure tu.
        </p>
      </div>
    </div>
  );
}

export default AvisCopia;
